import { MODAL_IDS } from '../ModalProvider'

export const checkIsLastLayer = (modalId: string, modals: { id: `${MODAL_IDS}` }[]) => {
  const lastElement = modals.at(-1)
  if (!lastElement) {
    return false
  }

  return lastElement.id === modalId
}
